import { LoadingStatusType, TypeComponentNoti } from "@/enums/enums";
import { DownloadExport } from "@/helper/exportHelper";
import { i18n } from "@/i18n";
import API from "@/service/Index";
import { Action, Module, Mutation, VuexModule } from "vuex-module-decorators";

@Module({ namespaced: true })
export default class Export extends VuexModule {
  public exportLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public exportFile: any = null;

  @Mutation
  public MutationExportLoadingStatus(exportLoadingStatus: LoadingStatusType) {
    this.exportLoadingStatus = exportLoadingStatus;
  }
  @Action
  public DoExportSSOSalary(salaryId: number) {
    if (this.exportLoadingStatus !== LoadingStatusType.Loading) {
      this.context.dispatch("Loading/IsLoading", true, { root: true });
      this.context.commit("MutationExportLoadingStatus", LoadingStatusType.Loading);
      API.ExportService.DoExportSSOSalary(salaryId).then((res) => {
        this.context.commit("MutationExportLoadingStatus", LoadingStatusType.Success);
        if (res.status.IsSuccess()) {
          DownloadExport(res.data.file);
        }
        this.context.dispatch("Loading/IsLoading", false, { root: true });
      });
    }
  }
  @Action
  public DoExportPayRunSalary(salaryId: number) {
    if (this.exportLoadingStatus !== LoadingStatusType.Loading) {
      this.context.dispatch("Loading/IsLoading", true, { root: true });
      this.context.commit("MutationExportLoadingStatus", LoadingStatusType.Loading);
      API.ExportService.DoExportPayRunSalary(salaryId).then((res) => {
        this.context.commit("MutationExportLoadingStatus", LoadingStatusType.Success);
        if (res.status.IsSuccess()) {
          DownloadExport(res.data.file);
        }
        this.context.dispatch("Loading/IsLoading", false, { root: true });
      });
    }
  }
  @Action
  public DoExportPayRunSalaryPeriod(input: any) {
    if (this.exportLoadingStatus !== LoadingStatusType.Loading) {
      this.context.dispatch("Loading/IsLoading", true, { root: true });
      this.context.commit("MutationExportLoadingStatus", LoadingStatusType.Loading);
      API.ExportService.DoExportPayRunSalaryPeriod(input).then((res) => {
        this.context.commit("MutationExportLoadingStatus", LoadingStatusType.Success);
        if (res.status.IsSuccess()) {
          if (res.data.file && res.data.file.fileName) {
            DownloadExport(res.data.file);
          } else {
            this.context.dispatch(
              "Alert/SetAlertMessage",
              { alertMessage: i18n.t("No_data_for_the_selected_time_period"), typeMessage: TypeComponentNoti.Error },
              { root: true }
            );
          }
        }
        this.context.dispatch("Loading/IsLoading", false, { root: true });
      });
    }
  }
  @Action
  public DoCreateLogExportBankFile(salaryId: number) {
    API.ExportService.DoCreateLogExportBankFile(salaryId);
  }
  @Action
  public DoExportImportTemplatePayRunSalary() {
    if (this.exportLoadingStatus !== LoadingStatusType.Loading) {
      this.context.dispatch("Loading/IsLoading", true, { root: true });
      this.context.commit("MutationExportLoadingStatus", LoadingStatusType.Loading);
      API.ExportService.DoExportImportTemplatePayRunSalary().then((res) => {
        this.context.commit("MutationExportLoadingStatus", LoadingStatusType.Success);
        if (res.status.IsSuccess()) {
          DownloadExport(res.data.file);
        }
        this.context.dispatch("Loading/IsLoading", false, { root: true });
      });
    }
  }
  @Action
  public DoExportEmployeeByDepartment(departmentId: number) {
    if (this.exportLoadingStatus !== LoadingStatusType.Loading) {
      this.context.dispatch("Loading/IsLoading", true, { root: true });
      this.context.commit("MutationExportLoadingStatus", LoadingStatusType.Loading);
      API.ExportService.DoExportEmployeeByDepartment(departmentId).then((res) => {
        this.context.commit("MutationExportLoadingStatus", LoadingStatusType.Success);
        if (res.status.IsSuccess()) {
          DownloadExport(res.data.file);
        }
        this.context.dispatch("Loading/IsLoading", false, { root: true });
      });
    }
  }
  @Action
  public DoExportPayRunSalaryPnd1(salaryId: number) {
    if (this.exportLoadingStatus !== LoadingStatusType.Loading) {
      this.context.dispatch("Loading/IsLoading", true, { root: true });
      this.context.commit("MutationExportLoadingStatus", LoadingStatusType.Loading);
      API.ExportService.DoExportPayRunSalaryPnd1(salaryId).then((res) => {
        this.context.commit("MutationExportLoadingStatus", LoadingStatusType.Success);
        if (res.status.IsSuccess()) {
          DownloadExport(res.data.file);
        }
        this.context.dispatch("Loading/IsLoading", false, { root: true });
      });
    }
  }
}
